import { render, staticRenderFns } from "./carousel-product-banners-cmp.vue?vue&type=template&id=0f4c2fbc&scoped=true"
import script from "./carousel-product-banners-cmp.vue?vue&type=script&lang=js"
export * from "./carousel-product-banners-cmp.vue?vue&type=script&lang=js"
import style0 from "./carousel-product-banners-cmp.vue?vue&type=style&index=0&id=0f4c2fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c2fbc",
  null
  
)

export default component.exports